



















































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Store } from 'vuex';
import { FmvAvatar } from 'fmv-avatar';
import MdIcon from '../../components/vui-luma/Ui/MdIcon.vue';
import { api } from '@/api';

@Component({
  components: {
    FmvAvatar,
    MdIcon,
  },
})
export default class TeamItems extends Vue {
  @Prop({default: []}) public items!: string[];
  @Prop({default: ''}) public tokenParam!: string;
  @Prop({default: null}) public level!: number;
  @Prop({default: null}) public parentId!: number;

  public getLevelMargin(level) {
    return (level - 1) * 30;
  }

  public async loadRefs(userId) {
    const response = await api.getUserPkRefs(userId, this.tokenParam);
    if (response.data) {
      return response.data;
    } else {
      return [];
    }
  }

  public async toggleTeamItems(parId, level) {
    const parentListElIcon = document.getElementById(`parent-team-list-icon-${parId}`);

    if (document.getElementById(`team-list-items-${parId}`)) {
      // create component constructor
      const teamComponent = Vue.extend(TeamItems);
      const newItems = await this.loadRefs(parId);

      new teamComponent({
        propsData: {
          tokenParam: this.tokenParam,
          parentId: parId,
          level: level + 1,
          items: newItems,
        },
      }).$mount(`#team-list-items-${parId}`);
      // @ts-ignore
      parentListElIcon.innerText = 'remove';
    } else {
      const parentListEl = document.getElementById(`parent-team-list-items-${parId}`);
      // @ts-ignore
      parentListEl.style.display = parentListEl.style.display === 'none' ? 'block' : 'none';
      // @ts-ignore
      parentListElIcon.innerText = parentListEl.style.display === 'none' ? 'add' : 'remove';
    }
  }
}
